var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition-group",
    {
      staticClass: "listing-feed__set",
      attrs: { tag: "div", appear: "", "data-layout": "3", name: "fade-up" }
    },
    _vm._l(_vm.data, function(item, index) {
      return _c("event-card", {
        key: item.Id,
        attrs: {
          "hide-tags": _vm.hideTags,
          "default-selected-tags": _vm.defaultSelectedTags,
          item: item,
          index: index
        }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }